import { Component, TemplateRef, Output, EventEmitter, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SelectlanguageComponent } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { environment } from 'src/environments/environment';
import { UserInfo } from './../Models/UserInfo';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { EventsService } from '../../services/events.service';
import { TranslationKeys } from '../../../../../../../Frontend/Common/ph-bhp-common-library/dist/ph-bhp-localization';
import { AppConfig } from 'src/app/app.config';
import { TranslateService } from '@ngx-translate/core';
import { checkLocalizationLang } from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/lib/translation.utilities';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PHBHPFeaturePackageConfigurationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-configuration/lib/ph-bhp-feature-package-configuration.service';

@Component({
  selector: 'lib-ph-bhp-header',
  templateUrl: './ph-bhp-header.component.html',
  styleUrls: ['./ph-bhp-header.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 1 })),
      state('out', style({ opacity: 0, display: 'none' })),
      transition('in => out', [
        animate('0.2s ease-out')
      ]),
      transition('out => in', [
        animate('0.2s ease-in')
      ])
    ])
  ]
})
export class PHBHPHeaderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() institutions: any;
  @Input() userData: any;
  @Input() appUrl: any;
  @Output() childData = new EventEmitter();

  translationKeys: typeof TranslationKeys = TranslationKeys;

  subscription: Subscription;
  modalRef: BsModalRef;
  message: string;
  UserImage: any;
  appMenu: boolean = false;
  profileMenu: boolean = false;
  helpMenu: boolean = false;
  notificationMenu: boolean = false;
  contactMenu: boolean = false;
  contactData: any = {};
  serviceMenu: boolean = false;
  subscribedServices: any = [];
  nonSubscribedServices: any = [];
  InstitutionsList: [any];
  env = environment;
  itemChange: boolean = false;
  choosenlang: any;
  serverUrl: string;
  helpFileURL
  selectedInstitution;
  langSelectorVisible = false;

  platformURLDashboard: string;
  loginID: string;
  pinpointURL: string;
  adminEndpointAPI: string;
  APISignature: string;

  constructor(
    public translate: TranslateService,
    private sanitizer: DomSanitizer,
    public layoutService: PHBHPLayoutPackageService,
    public service: PHBHPListApiService,
    private modalService: BsModalService,
    public config: AppConfig,
    private eventsService: EventsService,
    private configService: PHBHPFeaturePackageConfigurationService,
    private router: Router
  ) {
    this.serverUrl = layoutService.serverUrl;
    this.platformURLDashboard = 'http://dev-www-hartmann-info.hrt.cloud/observe/dashboard';
    this.loginID = '';
    this.pinpointURL = 'https://sit-auth-api-hartmann-info.hrt.cloud/api/';
    this.adminEndpointAPI = 'https://sit-auth-api-hartmann-info.hrt.cloud/api/v0.4/';
    this.APISignature = 'AppManager/GetAppManagerDetailsByUser';
  }
  optionsLang;

  ngOnInit() {
    this.loginID = localStorage.getItem('user_token');
    let lang = this.uppercase(localStorage.getItem('selectedlanguage'));

    this.choosenlang = lang ? (lang =='null'? 'en': lang) : 'en';
    if (localStorage.getItem('Lang') && (localStorage.getItem('Lang') == 'de' || localStorage.getItem('Lang') == 'en')) {
      let key = 'selectedlanguage';
      localStorage.setItem(key, localStorage.getItem('Lang'));
      this.choosenlang = localStorage.getItem('Lang');
      this.selectLanguage(localStorage.getItem('Lang'));
    }

    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.onInstitutionChange(this.layoutService.institutionID);
    });
    this.helpFileURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.env.helpUrl);

    this.optionsLang = [
      {
        language: this.translationKeys.Label.English,
        value: "en"
      },
      {
        language: this.translationKeys.Label.German,
        value: "de"
      },
      {
        language: this.translationKeys.Label.Hungarian,
        value: "hu"
      },
      {
        language: this.translationKeys.Label.Spanish,
        value: "es"
      },
      {
        language: this.translationKeys.Label.French,
        value: "fr"
      },
      {
        language: this.translationKeys.Label.Italian,
        value: "it"
      },
      {
        language: this.translationKeys.Label.Czeck,
        value: "cs"
      },
      {
        language: this.translationKeys.Label.Slovakian,
        value: "sk"
      },
      {
        language: this.translationKeys.Label.Dutch,
        value: "nl"
      },
      {
        language: this.translationKeys.Label.Catalan,
        value: "ca"
      }, {
        language: this.translationKeys.Label.Portuguese,
        value: "pt"
      },
    ];
  }

  ngOnChanges() {
    if (this.userData) {
      this.OnInstitutionsChanges();
    }
  }

  selectLanguage(value) {
    this.layoutService.showLoader = true;

    if (this.config.userData) {
      if (value == 'de') {
        value = checkLocalizationLang(this.translate, value, this.config.userData.roleName.roleId == 1 ? this.config.userData.country : this.layoutService.institutionCountryId);
      }
    }

    this.translate.use(value).subscribe(() => {
      let key = 'selectedlanguage';
      localStorage.setItem(key, value);
      this.choosenlang = value;
      if (localStorage.getItem('Lang') && (this.choosenlang == 'en' || this.choosenlang == 'de')) {
        let healthPlusKey = 'Lang';
        localStorage.setItem(healthPlusKey, value);
      }

      this.layoutService.lang.next(value);

      setTimeout(() => {
        this.layoutService.showLoader = false;
      }, 500);
    }, (error) => {
      this.layoutService.showLoader = false;
    });
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
  OnInstitutionsChanges() {
    if (this.institutions && !this.itemChange) {
      var roleId = this.userData.roleName.roleId
      this.itemChange = true;
      this.service.getInstitutionsbyId(this.institutions, roleId).subscribe((res: any) => {
        this.InstitutionsList = res;
        var institutionID;
        if (this.layoutService.institutionID) {
          institutionID = this.layoutService.institutionID;
        } else {
          if (res.length > 0) {
            institutionID = res[0].institution.institutionID;
          }
        }
        this.onInstitutionChange(institutionID);
      })
    }
  }

  onInstitutionChange(value) {
    if (this.InstitutionsList && this.InstitutionsList.length > 0 && value) {
      this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === value)?.institution?.institutionName || '';
    }
  }

  menuChildData(event) {
    switch (event.key) {
      case 'imageUpdated':
        this.UserImage = event.data
        break;
      case 'submenuLinkClick':
        this.helpMenu = false; this.notificationMenu = false; this.profileMenu = false; this.appMenu = false
        break;
      default:
        this.childData.emit(event);
    }
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static'
    });
  }

  toggleLangSelect() {
    this.langSelectorVisible = !this.langSelectorVisible;
  }
  closeLangSelect() {
    this.langSelectorVisible = false;
  }

  openlangmodal() {
    this.modalRef = this.modalService.show(SelectlanguageComponent, {});
    this.eventsService.languageSelectedEvent.subscribe((value) => {
      this.choosenlang = this.uppercase(value.value);
      this.layoutService.lang.next(value.value);
    });
  }

  uppercase(value) {
    return value;
  }

  newMessage() {
    this.layoutService.expandedMenu = !this.layoutService.expandedMenu;
  }
  getEventAppMenu(event) {
    this.appMenu = event.val;
  }
  getEventHelpMenu(event) {
    this.helpMenu = event.val;
  }
  // getEventNotificationMenu(event) {
  //   this.notificationMenu = event.val;
  // }
  getEventProfileMenu(event) {
    this.profileMenu = event.val;
  }

  openProfileMenu() {
    this.helpMenu = false;
    this.notificationMenu = false;
    this.appMenu = false;
    this.contactMenu = false;
    this.serviceMenu = false;
    this.profileMenu = true;
  }

  openServiceMenu() {
    this.profileMenu = false;
    this.helpMenu = false;
    this.notificationMenu = false;
    this.appMenu = false;
    this.contactMenu = false;
    this.serviceMenu = true;
  }

  // openContactMenu() {
  //   this.profileMenu = false;
  //   this.helpMenu = false;
  //   this.notificationMenu = false;
  //   this.appMenu = false;
  //   this.contactMenu = false;
  //   this.serviceMenu = false;;
  //   this.layoutService.showLoader = true;
  //   this.service.getContactDetailsByInstitution(this.layoutService.institutionID).subscribe((data) => {
  //     if (data) {
  //       this.contactData = data;
  //       this.contactMenu = true;
  //     } else {
  //       this.layoutService.showError(this.layoutService.translateText('LABEL.SUPPORT_MENU.ERROR'));
  //     }

  //     this.layoutService.showLoader = false;
  //   });
  // }

  getEventContactMenu(event) {
    this.contactMenu = event.val;
  }

  getEventServiceMenu(event) {
    this.serviceMenu = event.val;
  }

  openAppDownloadPopup(id) {
    this.modalRef = this.modalService.show(id, {
      animated: true,
      backdrop: 'static'
    });
  }

  moveToTutorials() {
    this.router.navigate([`/elearning/manage`]);
  }

  onEmitEvent(event) {
    switch (event.event) {
      case 'subscribeAlert':
        this.layoutService.showSuccess(event.val);
        break;
      case 'setSubscriptionValue':
        this.layoutService.showSuccess(event.val);
        break;
      case 'navigateToExplore':
        if (event.event.appUrl) {
          window.open(event.event.appUrl, "_blank");
        }
        break;
    }
  }

  expandMenu() {
    this.layoutService.expandedMenu = !this.layoutService.expandedMenu;
  }

  sendEmailToSupport() {
    this.layoutService.showLoader = true;
    var userData: any = JSON.parse(localStorage.getItem('userData'));
    var roleData = userData ? JSON.parse(userData.roleName) : null;
    if (roleData && roleData.roleId < 3) {
      this.configService.getSupportEmailById(userData.country, false).subscribe((res: any) => {
        if (res) {
          var email = res.supportEmail;
          window.open(`mailto:${email}`)
        } else {
          this.layoutService.showError(this.layoutService.translateText('LABEL.SUPPORT_MENU.ERROR'));
        }
        this.layoutService.showLoader = false;
      });
    } else {
      var institutionId = localStorage.getItem('selectedInstitution');
      this.configService.getSupportEmailById(institutionId, true).subscribe((res: any) => {
        if (res) {
          var email = res.supportEmail;
          window.open(`mailto:${email}`)
        } else {
          this.layoutService.showError(this.layoutService.translateText('LABEL.SUPPORT_MENU.ERROR'));
        }
        this.layoutService.showLoader = false;
      });
    }
  }
}
